import { useQuery } from '@tanstack/react-query'

import { fetchAdminFiles, fetchAdminUsersActivity } from 'modules/admin/api'
import { adminKeys } from 'modules/admin/query-keys'

export const useAdminFilesQuery = () => {
  return useQuery({
    queryKey: adminKeys.files(),
    queryFn: () => fetchAdminFiles(),
  })
}

export const useAdminUsersActivityQuery = () => {
  return useQuery({
    queryKey: adminKeys.usersActivity(),
    queryFn: () => fetchAdminUsersActivity(),
  })
}
